import { createFileRoute, redirect } from "@tanstack/react-router";
import { DuplicatesClient } from "@/features/locations/DuplicatesClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Organisaties → Locaties → Dubbelen: the addresses with more than one location, to join what is
// one place (docs/tms-stamdata.md S61). Joining is managing locations: tms_locations_write - here,
// and on the API regardless.
export const Route = createFileRoute("/_shell/locations/duplicates")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin") && !hasModule(context.session, "tms_locations_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: LocationDuplicatesScreen,
});

function LocationDuplicatesScreen() {
  return (
    <div className="wl-page" data-screen-label="Back-office Location Duplicates">
      <DuplicatesClient />
    </div>
  );
}
